var map = {
	"./aiText/en.json": 80724,
	"./aiText/es.json": 97130,
	"./aiText/pt.json": 19610,
	"./common/en.json": 99706,
	"./common/es.json": 54707,
	"./common/pt.json": 87879,
	"./music-recap/en.json": 89435,
	"./music-recap/es.json": 98206,
	"./music-recap/pt.json": 25384,
	"./share/en.json": 85984,
	"./share/pt.json": 5398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71267;